import { LinkAnchor } from '@treetop/shared/model';

import { FlowchartElementsSubjectStore } from '../../../data/flowchart-elements-subject-store.service';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace LinkValidator {
  // Prevent linking if there is an existing link in between elements.
  export function doElementsHaveLinkInBetween(graph: joint.dia.Graph, cellViewS: joint.dia.CellView, targetId: string) {
    const sourceCell = graph.getCell(cellViewS.model.attributes.id);
    const connectedOutgoingLinks = graph.getConnectedLinks(sourceCell, { outbound: true });
    const alreadyConnectedLink = connectedOutgoingLinks.find((el) => el.attributes.target.id === targetId);

    if (alreadyConnectedLink) {
      return true;
    }
  }

  // Prevent linking if target magnet is not defined
  export function isTargetMagnetDefined(magnetT: SVGElement) {
    if (magnetT) {
      return true;
    }
  }

  // Prevent linking if the connection is between same element
  export function doesLinkConnectToAnotherElement(cellViewS: joint.dia.CellView, cellViewT: joint.dia.CellView) {
    if (cellViewS === cellViewT) {
      return false;
    }

    return true;
  }

  // Prevent linking between other links
  export function doesLinkConnectToElement(cellViewS: joint.dia.CellView, cellViewT: joint.dia.CellView) {
    if (cellViewT.model.isLink() || cellViewS.model.isLink()) {
      return false;
    }

    return true;
  }

  // Prevent a connection without port (to target center) if top connection exists
  export function allowConnectionOnElementBody(
    flowchartElementsSubjectStore: FlowchartElementsSubjectStore,
    cellViewS,
    cellViewT,
    magnetS,
    magnetT,
  ) {
    const flowchartElementS = flowchartElementsSubjectStore.getValue().find((el) => el.id === cellViewS.model.id);
    const existingTopConnection = flowchartElementS?.outgoingLinks?.find(
      (link) => link.toFlowchartNodeId === cellViewT.model.id && link.toFlowchartNodeAnchor == LinkAnchor.Top,
    );
    if (!magnetT && cellViewT && existingTopConnection) {
      return false;
    }

    if (!magnetS || !magnetT) {
      return true;
    }

    return true;
  }

  export function doesLinkConnectInsideElementWithSubflowElement(cellViewS: joint.dia.CellView, cellViewT: joint.dia.CellView) {
    if (cellViewS.model.attributes?.subflowParentId && !cellViewT.model.attributes?.subflowParentId) {
      // Source is in subflow, target is not
      return false;
    }

    if (!cellViewS.model.attributes?.subflowParentId && cellViewT.model.attributes?.subflowParentId) {
      // Source is not in subflow, target is
      return false;
    }

    if (
      cellViewS.model.attributes?.subflowParentId &&
      cellViewT.model.attributes.subflowParentId &&
      cellViewS.model.attributes.subflowParentId !== cellViewT.model.attributes.subflowParentId
    ) {
      // Source and target are in different subflows
      return false;
    }

    return true;
  }
}
